import React from 'react';
import { useSelector } from 'react-redux';

const DepartmentAndCategories = () => {
	const brandProfile = useSelector((store) => store.brandProfileStore);

	return (
		<section className="body-content">
			<iframe
				title={brandProfile.name}
				width="1140"
				height="541.25"
				src={brandProfile.powerBiUrl}
				frameBorder="0"
				allowFullScreen="true"
			/>
		</section>
	);
};

export default DepartmentAndCategories;
